import React, { useState, useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

export default function VideoSection() {
  const [zoomLevel, setZoomLevel] = useState(1);
  const [isZooming, setIsZooming] = useState(false);

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  const handleWheel = (event) => {
    event.preventDefault();
    const delta = event.deltaY || event.detail || event.wheelDelta;
    if (delta < 0) {
      setZoomLevel((prev) => Math.min(prev + 0.1, 2));
    } else {
      setZoomLevel((prev) => Math.max(prev - 0.1, 0.5));
    }
    setIsZooming(true);
  };

  const handleMouseUp = () => {
    setIsZooming(false);
  };

  useEffect(() => {
    window.addEventListener("wheel", handleWheel);
    window.addEventListener("mouseup", handleMouseUp);

    return () => {
      window.removeEventListener("wheel", handleWheel);
      window.removeEventListener("mouseup", handleMouseUp);
    };
  }, []);

  return (
    <div
      className="relative w-full h-screen overflow-hidden bg-gray-900"
      style={{
        cursor: isZooming
          ? "url('https://img.freepik.com/premium-vector/play-button-flat-icon-isolated-white-background_967223-723.jpg'), auto"
          : "auto",
      }}
    >
      <video
        className="absolute top-0 left-0 w-full h-full object-cover transition-transform duration-500"
        style={{ transform: `scale(${zoomLevel})` }}
        src="https://videos.pexels.com/video-files/7849764/7849764-uhd_2732_1440_25fps.mp4"
        type="video/mp4"
        loop
        autoPlay
        muted
      />
      {isZooming && (
        <p className="absolute bottom-4 left-4 px-3 py-1 text-white text-lg bg-black bg-opacity-60 rounded-lg shadow-lg">
          Zoom level: {zoomLevel.toFixed(1)}
        </p>
      )}

      {/* Responsive Product Cards with AOS animations */}
      {zoomLevel <= 0.5 && (
        <div className="absolute inset-0 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 p-8 bg-opacity-70 bg-gray-900 backdrop-blur-md transition-opacity duration-300">
          {[
            {
              title: "UI Design",
              description: "Professional UI design services",
              imgSrc: "https://img.freepik.com/premium-photo/dark-mode-mobile-app-ui-design_1179475-17689.jpg",
            },
            {
              title: "UX Design",
              description: "User experience optimization",
              imgSrc: "https://img.freepik.com/free-vector/gradient-ui-ux-background_23-2149051557.jpg",
            },
            {
              title: "Web Development",
              description: "Modern web solutions",
              imgSrc: "https://img.freepik.com/premium-photo/3d-cartoon-character-developer-working-laptop-web-app-development-frontend-deployment_1298309-24267.jpg",
            },
            {
              title: "Cybersecurity",
              description: "Protecting digital assets",
              imgSrc: "https://img.freepik.com/premium-photo/cyber-protection-digital-security-system-concept-virtual-shield-protect-cryptocurrency-technology_660230-74699.jpg",
            },
          ].map((service, index) => (
            <div
              key={index}
              data-aos="fade-up"
              className="group perspective relative bg-transparent p-6 rounded-2xl shadow-lg hover:shadow-2xl transition duration-300 transform hover:-translate-y-2 flex flex-col items-center text-center"
            >
              <div className="relative w-full h-48 sm:h-60 lg:h-72 rounded-2xl overflow-hidden shadow-lg transform transition-all duration-300 group-hover:scale-105">
                <img
                  src={service.imgSrc}
                  alt={service.title}
                  className="absolute inset-0 w-full h-full object-cover transition duration-300"
                />
                <div className="absolute inset-0 flex flex-col items-center justify-center bg-black bg-opacity-40 transition-opacity duration-300 opacity-0 group-hover:opacity-100">
                  <h3 className="text-lg font-bold text-white">{service.title}</h3>
                  <p className="text-white text-sm">{service.description}</p>
                </div>
              </div>
              <button className="mt-4 px-4 py-2 text-white bg-indigo-600 rounded-full shadow-md hover:bg-indigo-700 transition duration-300">
                Learn More
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
